const signInConfig = (signIn = false, action) => {
  switch (action.type) {
    case "GET_SIGNIN":
      return action.playload;
    default:
      return signIn;
  }
};
export default signInConfig;
